import React, { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { Spin } from 'antd';

import { FunctionalRootState, getPreferenceFileUrlFromAccount, } from '@share/utils';
import { forgot, ILoginState, IPasswordState } from '@share/store/slices';
import { BACKGROUND_PHOTO_FIELD_KEY, IAccount } from '@share/common-types';
import { Routes } from '@share/constants';

import AshevillePlayMain from '@assets/images/ashevilleplay/asheville-hero.jpg';

import './style.scss';

export function ForgotPasswordAshevillePlay() {

  const loginStore: ILoginState = useSelector((state: FunctionalRootState) => state.loginStore);
  const passwordStore: IPasswordState = useSelector((state: FunctionalRootState) => state.passwordStore);

  const { account } = loginStore;
  const { loading } = passwordStore;

  const dispatch = useDispatch();

  const history = useHistory();

  const [formData, setFormData] = useState({
    email: '',
  });
  
  const [errors, setErrors] = useState<{
    email?: string;
  }>({});
    
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    // Clear error when user starts typing
    if (errors[name as keyof typeof errors]) {
      setErrors(prev => ({ ...prev, [name]: undefined }));
    }
  };
  
  const validateForm = () => {
    const newErrors: typeof errors = {};
    
    if (!formData.email) {
      newErrors.email = 'Current password is required';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
        
    dispatch(forgot(formData.email, true));
  };
  
  const onNavigateToHome = () => {
    history.push(`/${account?.name}${Routes.Search}`);
  };

  const onNavigateToLogin = () => {
    history.push(`/${account?.name}${Routes.Login}`);
  };

  const backgroundImage = getPreferenceFileUrlFromAccount(account as IAccount, BACKGROUND_PHOTO_FIELD_KEY);
  const image = backgroundImage ? backgroundImage : AshevillePlayMain;

  const logoDB = account?.ashevillePlayGoogleLogo;

  return (
    <div className="login-page-asheville-play" style={{ backgroundImage: `linear-gradient(135deg, rgba(26, 26, 26, 0.4) 0%,rgba(26, 26, 26, 0.2) 100%), url(${image})` }}>
      <div className="logo-top-left" onClick={onNavigateToHome}>
        <img src={logoDB} alt="Asheville Play" />
      </div>

      <div className="login-card">
        <div className="login-card-header">
          <div className="logo-container">
            <h1 className="logo-text">Asheville Play</h1>
            <p className="logo-subtitle">Your Asheville starts here</p>
          </div>
          <h3 style={{ fontSize: '35px' }}>Forgot Password</h3>
        </div>
        
        <div style={{ marginBottom: '1rem' }}>
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label className="input-label" htmlFor="email"><FormattedMessage id="forgot.password" /></label>
              <input
                id="email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Enter email"
                className={`input-email-field ${errors.email ? 'error' : ''}`}
              />
              {errors.email && <span className="input-error">{errors.email}</span>}
            </div>
                        
            <button className="full-width-button" type="submit" disabled={loading}>
              {loading ? <Spin size="small" style={{ marginRight: '10px' }} /> : null} <FormattedMessage id="send.email" />
            </button>
          </form>
        </div>

        <div className="signup-section">
          <p className="signup-text">Already have an account?</p>
          <button className="text-button"
            type="button"
            onClick={onNavigateToLogin}
            style={{ fontSize: '1rem' }}
          >
            Sign in
          </button>
        </div>

      </div>
    </div>
  );
};
